/**
 * 請求・収納API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RequestCommon { 
    /**
     * 業務日付
     */
    businessDate?: string;
    /**
     * 取得開始行
     */
    startLine?: number;
    /**
     * 取得件数
     */
    getNumber?: number;
    /**
     * ドライラン
     */
    dryRun?: boolean;
    /**
     * 業務リクエストID：半角
     */
    businessReqId?: string;
    /**
     * 機能連携ID：半角
     */
    funcLinkId?: string;
    /**
     * リクエストカスタマイズエリア
     */
    requestCustomize?: object;
}

